var map = {
	"./diamante-black.png": "d134",
	"./diamante.png": "50dc",
	"./esmeralda.png": "2321",
	"./imperial-hd.png": "3710",
	"./index.html": "2a19",
	"./platina.png": "5737",
	"./royal-hd.png": "f0fe",
	"./ruby.png": "a0a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";